var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuideIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "guideIcon1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1251",
    "data-name": "\\uD0C0\\uC6D0 1251",
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "guide1",
    transform: "translate(9.527 9.527)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34160",
    "data-name": "\\uD328\\uC2A4 34160",
    d: "M248.5,105v17.87a8.935,8.935,0,1,0,0-17.87Z",
    transform: "translate(-233.027 -98.462)",
    fill: "#ffab37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34161",
    "data-name": "\\uD328\\uC2A4 34161",
    d: "M121,113.935C121,109,117.838,105,113.935,105a8.935,8.935,0,1,0,0,17.87C117.838,122.87,121,118.87,121,113.935Z",
    transform: "translate(-98.462 -98.462)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34162",
    "data-name": "\\uD328\\uC2A4 34162",
    d: "M235.368,453.868V452H233.5v1.868a.934.934,0,0,0,1.868,0Z",
    transform: "translate(-218.961 -423.857)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34163",
    "data-name": "\\uD328\\uC2A4 34163",
    d: "M234.434,424.8a.934.934,0,0,0,.934-.934v-.934a.934.934,0,1,0-1.868,0v.934A.934.934,0,0,0,234.434,424.8Z",
    transform: "translate(-218.961 -395.724)",
    fill: "#ffde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34164",
    "data-name": "\\uD328\\uC2A4 34164",
    d: "M384.432,383.111l-1.321-1.321-1.321,1.321,1.321,1.321a.934.934,0,0,0,1.321-1.321Z",
    transform: "translate(-358.018 -358.018)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34165",
    "data-name": "\\uD328\\uC2A4 34165",
    d: "M369.044,369.044a.934.934,0,0,0,0-1.321l-.66-.66a.934.934,0,0,0-1.321,1.321l.66.66A.934.934,0,0,0,369.044,369.044Z",
    transform: "translate(-343.952 -343.952)",
    fill: "#ffde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34166",
    "data-name": "\\uD328\\uC2A4 34166",
    d: "M217.567,0h-1.781a.467.467,0,0,0-.418.258l-.8,1.61,2.113,1.868,2.113-1.868-.8-1.61A.467.467,0,0,0,217.567,0Z",
    transform: "translate(-201.204 0)",
    fill: "#d3dee1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34167",
    "data-name": "\\uD328\\uC2A4 34167",
    d: "M453.868,233.5H452v1.868h1.868a.934.934,0,0,0,0-1.868Z",
    transform: "translate(-423.857 -218.961)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34168",
    "data-name": "\\uD328\\uC2A4 34168",
    d: "M424.8,234.434a.934.934,0,0,0-.934-.934h-.934a.934.934,0,1,0,0,1.868h.934A.934.934,0,0,0,424.8,234.434Z",
    transform: "translate(-395.724 -218.961)",
    fill: "#ffde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34169",
    "data-name": "\\uD328\\uC2A4 34169",
    d: "M383.111,68.664l-1.321,1.321,1.321,1.321,1.321-1.321a.934.934,0,0,0-1.321-1.321Z",
    transform: "translate(-358.018 -64.132)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34170",
    "data-name": "\\uD328\\uC2A4 34170",
    d: "M369.044,89.877a.934.934,0,0,0-1.321,0l-.66.66a.934.934,0,0,0,1.321,1.321l.66-.66A.934.934,0,0,0,369.044,89.877Z",
    transform: "translate(-343.952 -84.024)",
    fill: "#ffde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34171",
    "data-name": "\\uD328\\uC2A4 34171",
    d: "M68.664,69.985l1.321,1.321,1.321-1.321-1.321-1.321a.934.934,0,1,0-1.321,1.321Z",
    transform: "translate(-64.132 -64.132)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34172",
    "data-name": "\\uD328\\uC2A4 34172",
    d: "M89.877,89.877a.934.934,0,0,0,0,1.321l.66.66a.934.934,0,0,0,1.321-1.321l-.66-.66A.934.934,0,0,0,89.877,89.877Z",
    transform: "translate(-84.024 -84.024)",
    fill: "#ffde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34173",
    "data-name": "\\uD328\\uC2A4 34173",
    d: "M.934,235.368H2.8V233.5H.934a.934.934,0,1,0,0,1.868Z",
    transform: "translate(0 -218.961)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34174",
    "data-name": "\\uD328\\uC2A4 34174",
    d: "M30,234.434a.934.934,0,0,0,.934.934h.934a.934.934,0,1,0,0-1.868h-.934A.934.934,0,0,0,30,234.434Z",
    transform: "translate(-28.132 -218.961)",
    fill: "#ffde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34175",
    "data-name": "\\uD328\\uC2A4 34175",
    d: "M69.985,384.432l1.321-1.321-1.321-1.321-1.321,1.321a.934.934,0,0,0,1.321,1.321Z",
    transform: "translate(-64.132 -358.018)",
    fill: "#ffcd37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34176",
    "data-name": "\\uD328\\uC2A4 34176",
    d: "M89.877,369.044a.934.934,0,0,0,1.321,0l.66-.66a.934.934,0,0,0-1.321-1.321l-.66.66A.934.934,0,0,0,89.877,369.044Z",
    transform: "translate(-84.024 -343.952)",
    fill: "#ffde7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34177",
    "data-name": "\\uD328\\uC2A4 34177",
    d: "M269.3,30h-1.868v4.67h2.8V30.934A.934.934,0,0,0,269.3,30Z",
    transform: "translate(-250.781 -28.132)",
    fill: "#4f575b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34178",
    "data-name": "\\uD328\\uC2A4 34178",
    d: "M189.724,30H185.5a.934.934,0,0,0-.934.934V34.67h6.094V30.934A.934.934,0,0,0,189.724,30Z",
    transform: "translate(-173.072 -28.132)",
    fill: "#697276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34179",
    "data-name": "\\uD328\\uC2A4 34179",
    d: "M284.3,90h-1.868v1.868H284.3a.934.934,0,0,0,0-1.868Z",
    transform: "translate(-264.847 -84.396)",
    fill: "#353a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_34180",
    "data-name": "\\uD328\\uC2A4 34180",
    d: "M177.526,90.934a.934.934,0,0,0-.934-.934H170.5a.934.934,0,1,0,0,1.868h6.094A.934.934,0,0,0,177.526,90.934Z",
    transform: "translate(-159.006 -84.396)",
    fill: "#4f575b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideIcon1);
export default __webpack_public_path__ + "static/media/guideIcon1.1233184ecab7c3739138d2acd6b8102f.svg";
export { ForwardRef as ReactComponent };